<template>
    <v-container>
        <v-card v-if="isAdmin">
            <v-card-text>
                <v-container>
                    <v-layout d-block>
                        <v-flex v-for="(downloadOption, i) in downloadOptions" v-bind:key="i">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                            large
                                            block
                                            v-on="on"
                                            :href="downloadOption.url"
                                    >{{ downloadOption.option }}
                                    </v-btn>
                                </template>
                                <span>{{ downloadOption.tooltip }}</span>
                            </v-tooltip>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
        <v-card>
            <v-card-text>
                <v-container>
                    <v-layout d-block>
                        <v-flex v-if="listIsEmpty">
                            <v-progress-linear :indeterminate="true"></v-progress-linear>
                        </v-flex>
                        <v-flex v-for="file in listOfFiles" v-bind:key="file.weekNumber">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                            large
                                            block
                                            v-on="on"
                                            :href="renderUrl(file)"
                                    >Week {{ file.weekNumber }} ({{ file.count }})
                                    </v-btn>
                                </template>
                                <span>{{ renderDate(file.startDate) + " t/m " + renderDate(file.endDate) }}</span>
                            </v-tooltip>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import {dataSummaryService} from "@/services/admin";
import {mapGetters} from "vuex";

export default {
  name: "allDownload",
  data: () => ({
    listOfFiles: [],
    downloadOptions: [
      {
        "option": "Download alles (alle vragen)",
        "url": "/api/v1/data/export",
        "tooltip": "Alle vragen die beschikbaar zijn in de applicatie"
      }
    ]
  }),
  computed: {
    ...mapGetters(["isAdmin"]),
      listIsEmpty() {
          return this.listOfFiles.length === 0;
      }
  },
  methods: {
    renderDate(ISODateString) {
      const date = new Date(ISODateString);
      return date.toLocaleDateString("nl-NL");
    },
    renderUrl(csvFile) {
      return (
        "/api/v1/data/export?week=" +
        csvFile.weekNumber +
        "&year=" +
        csvFile.year
      );
    },
    enableExtraOptions() {
      this.extraOptionsEnabled = this.isExpert;
    },
    populate() {
      dataSummaryService
        .resolveDownloadAllSummary()
        .then(result => (this.listOfFiles = result.data))
        // eslint-disable-next-line
        .catch(() => console.log("Error!"));
    }
  },
  created() {
    this.populate();
  }
};
</script>